import styled, { css } from 'styled-components';

export const ulStyles = css`
	list-style: none;
	padding-left: ${props => props.theme.spacing * 1.5}rem;
`;

export const liStyles = css`
	position: relative;
	margin-bottom:  ${props => props.theme.spacing / 2}rem;

	&:before {
		content: '';
		position: absolute;
		left: -${props => props.theme.spacing * 1.5}rem; top: ${props => props.theme.spacing * 0.65}rem;
		height: 6px; width: 6px;
		border-radius: 100%;
		background-color: ${props => props.theme.colors.primary};
	}
`;

export const Ul = styled.ul`
	${ulStyles};
`;

export const Li = styled.li`
	${liStyles}
`;
